/* eslint-disable react/jsx-sort-props */
import * as React from 'react';
import * as vars from '../../styles/variables';
import AccessibleSVG, { SVGProps } from '../../components/accessible-svg/AccessibleSVG';

/**
 * This is an auto-generated component and should not be edited
 * manually in contributor pull requests.
 *
 * If you have problems with this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
 *
 * If there are missing features in this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
 */

const Gear16 = (props: SVGProps) => (
    <AccessibleSVG width={16} height={16} viewBox="0 0 16 16" {...props}>
        <path
            fill={vars.bdlGray50}
            fillRule="evenodd"
            d="M9.339 1a.82.82 0 01.822.7l.213 1.447c.258.12.506.26.745.422l1.428-.558c.374-.132.81.012 1.004.36l1.342 2.259a.82.82 0 01-.213 1.058l-1.185.902c.013.142.013.678 0 .82l1.187.903c.326.25.412.7.205 1.068l-1.33 2.238a.832.832 0 01-1.026.364l-1.415-.552c-.243.162-.49.303-.742.421l-.212 1.439a.822.822 0 01-.823.709H6.666a.82.82 0 01-.822-.7l-.214-1.447a5.379 5.379 0 01-.744-.422l-1.428.558c-.375.132-.81-.012-1.004-.36L1.11 10.37a.822.822 0 01.214-1.058l1.184-.902a9.343 9.343 0 010-.82l-1.186-.903a.812.812 0 01-.206-1.068l1.33-2.238a.832.832 0 011.026-.364l1.415.552c.244-.162.49-.303.742-.421l.212-1.439A.823.823 0 016.665 1h2.673zM8 5C6.347 5 5 6.346 5 8s1.346 3 3 3c1.653 0 3-1.346 3-3S9.654 5 8 5z"
        />
    </AccessibleSVG>
);

export default Gear16;
